<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
        @export="exportExcel"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :recordCode="editFormDialogOptions.code"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || 取消
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .thdapiOaFailureRecordListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, code = ''}) {
      const types = {
        detail:
          this.$l('form_label_editform_details') || 'OA接口日志详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    exportExcel(form) {
      let url = '/master/thdapiOaFailureRecord/export'
      let fileName = 'OA接口日志导出'
      this.$api.globalExportData(url, form, fileName)
    },
  },
}
</script>
